export type EncryptedCertificate = {
  version: string;
  nonce: string;
  ephemPublicKey: string;
  ciphertext: string;
  holderCommitment: string;
};

export type CertificateMetadata = {
  totalChunks: number;
  timestamp: number;
  holderCommitment: string;
  certificateId: string;
  standard: "gip1" | "gip2" | "gip3";
};

export const cloudStorageKeys = {
  certificates: "zkcerts-meta",
  certificate: (id: string, index: number) => `zkcert-${id}-${index}`,
  tasks: "tasks",
};
